import React, { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import "./Category.css";
import { getAllCategories } from "../../api/api";

class CategorySection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.loadCategories();
  }

  loadCategories = async () => {
    try {
      const res = await getAllCategories();
      this.setState({
        categories: res.data,
        loading: false,
      });
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  };

  render() {
    const { categories, loading } = this.state;

    return (
      <section className="services-section bg-light py-5 bottom-slant-gray">
        <div className="container">
          <div className="row text-center">

            {loading && <p>Loading Categories...</p>}

            {!loading &&
              categories.map((cat) => (
                <div
                  key={cat.category_id}
                  className="col-md-6 col-lg-3 mb-4 service-block"
                  onClick={() =>
                    this.props.router.navigate(
                      `/view-recipes?category_id=${cat.category_id}&category_name=${cat.category_name}`
                    )
                  }
                ><div className="category-image-wrapper">
                    <img
                      src={cat.category_image}
                      alt={cat.category_name}
                      className="category-image"
                    />
                  </div>

                  <div className="category-content">
                    <h4 className="category-title">
                      {cat.category_name}
                    </h4>

                    <p className="category-description">
                      {cat.category_details}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(CategorySection);